import { React, Fragment, memo, useEffect, useState } from 'react'
import {
  HeadingText,
  AddIcon,
  Row,
  Col,
  Button,
  Badge,
  Link,
} from '@paypalcorp/pp-react'

import { Message } from '@paypalcorp/worldready-react'

import TextBadge from '../../../components/TextBadge'
import serverData from '../../../utils/server-data'
import {
  DAR_SMC_DOWNLOAD_URL,
  DATA_DAR_CREATE_URL,
  DAR_SMC_DOWNLOAD_URL_NATIVE,
} from '../../../constants/constants'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import InfoList from '../../../config/dar-config'

const DATA_DAR_CREATE_NEW_URL =
  serverData.isInFrame && serverData.isMerchantUser
    ? `${DATA_DAR_CREATE_URL}?inframe=yes`
    : DATA_DAR_CREATE_URL

const DARHistory = memo(() => {
  const darFpti = DATAPRIVACY_FPTI.DAR_HISTORY
  const [impressionDone, setImpressionDone] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const { darHistory = [], isNative } = serverData
  const DAR_STATES = {
    OPEN: (
      <Badge type="success">
        <Message id="dar.history.request.status.open" />
      </Badge>
    ),
    INPROGRESS: (
      <Badge type="neutral">
        <Message id="dar.history.request.status.progress" />
      </Badge>
    ),
    WITHDRAWN: (
      <Badge type="neutral">
        <Message id="dar.history.request.status.expired" />
      </Badge>
    ),
    CLOSED: (
      <Button
        size="sm"
        onClick={() => {
          fptiCustomClick(darFpti.DOWNLOAD_BTN)
          location.href = isNative
            ? DAR_SMC_DOWNLOAD_URL_NATIVE
            : DAR_SMC_DOWNLOAD_URL
        }}
        className="text-badge-btn-download"
        secondary
      >
        <Message id="dar.history.request.status.download" />
      </Button>
    ),
  }
  const onClickCreateNew = () => {
    fptiCustomClick(darFpti.CREATENEW_BTN)
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(darFpti.IMPRESSION)
    }
    let categories = []

    categories = InfoList.map((section) => {
      let seclist = []
      if (Object.keys(section.infos).length === 0) {
        seclist.push({ category: section.name, info: section.value })
      } else {
        seclist = section.infos.map((info) => {
          return { category: section.name, info: info.value }
        })
      }
      return [...seclist]
    })
    setCategoryList(categories && [].concat(...categories))
  }, [])

  return (
    <Fragment>
      <Row className="requestHistory-header">
        <Col>
          <HeadingText
            id="darHistoryHeader"
            size="sm"
            className="requestHistory-header"
          >
            <Message id="dar.history.header.title" />
          </HeadingText>
          <Link
            href={DATA_DAR_CREATE_NEW_URL}
            className="createNew-link"
            onClick={onClickCreateNew}
          >
            <AddIcon />
            <Message id="dar.history.navigation.createNewLink" />
          </Link>
        </Col>
      </Row>
      {darHistory.map((dar, index) => {
        let infoCategory = []
        const { infos = [], status = '' } = dar
        infoCategory = infos.map((info) => {
          const filteredItem = categoryList.filter((val) => {
            return val.info === info.item
          })
          const categoryObj = {}

          Object.assign(categoryObj, filteredItem[0] || {})
          const values = Object.values(categoryObj)
          return values[0] || ''
        })
        const categoryUniq = [...new Set(infoCategory)] // removing duplicate elements from array
        const categoryGrp =
          categoryUniq && categoryUniq.length > 0 && categoryUniq.join('')

        const darInfoCateogry = categoryGrp && (
          <Message id={`dar.history.${categoryGrp}`} />
        )
        const counter = darHistory.length - index
        const badgestatus =
          status === 'CLOSED' ? (
            <Col md={4} xs={6} className="requestHistory_btn_download">
              {DAR_STATES[status]}
            </Col>
          ) : (
            <Col md={4} xs={4} className="text-badge-btn-align">
              {DAR_STATES[status]}
            </Col>
          )
        return (
          <TextBadge
            key={index}
            status={dar.status}
            date={dar.creationdate}
            title={counter.toString()}
            desc={darInfoCateogry}
            expiry={dar.daystoexpiry}
            badge={badgestatus}
          />
        )
      })}
    </Fragment>
  )
})

DARHistory.displayName = 'DARHistory'

export default DARHistory
